"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelText = exports.KeywordBlockerPanelHeader = exports.KeywordBlockerPanelBody = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _Textarea = _interopRequireDefault(require("../ui-components/Textarea"));

var _PanelItems = require("../registration-rules/PanelItems");

var _Message = require("../ui-components/Message");

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var KeywordBlockerPanelBody = function KeywordBlockerPanelBody(_ref) {
  var isKeywordBlockerEnabled = _ref.isKeywordBlockerEnabled,
      blockedWords = _ref.blockedWords,
      showActionButtons = _ref.showActionButtons,
      showValidationError = _ref.showValidationError,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      _onTextareaFocus = _ref.onTextareaFocus,
      onKeywordBlockerSettingChanged = _ref.onKeywordBlockerSettingChanged,
      onBlockedWordsChanged = _ref.onBlockedWordsChanged;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)(_Message.Message, {
    text: "Please note that the keyword blocker doesn\u2019t support ideation and product updates.",
    variant: "warning"
  }), (0, _preact.h)(_Message.Message, {
    text: "Users with the following roles are excluded from the filter: Administrator, Community Manager, Moderator, Superuser."
  }), (0, _preact.h)("div", {
    className: "panel-switch-textarea-container"
  }, (0, _preact.h)("div", {
    className: "switch-icon-container"
  }, (0, _preact.h)(_Switcher.default, {
    on: isKeywordBlockerEnabled,
    customClass: "panel-switch",
    labelCustomClass: "panel-switch-label",
    label: (0, _preact.h)(LabelText, null),
    onChange: function onChange() {
      return onKeywordBlockerSettingChanged(!isKeywordBlockerEnabled);
    }
  })), (0, _preact.h)("div", {
    className: "panel-textarea-container"
  }, (0, _preact.h)(_Textarea.default, {
    value: blockedWords === null || blockedWords === void 0 ? void 0 : blockedWords.join(', '),
    disabled: !isKeywordBlockerEnabled,
    newStyle: true,
    adjustHeight: false,
    placeholder: "Add keywords...",
    onTextareaFocus: function onTextareaFocus() {
      return _onTextareaFocus();
    },
    onContentChange: function onContentChange(value) {
      return onBlockedWordsChanged(value.trim());
    },
    class: "panel-text-area ".concat(showValidationError ? 'panel-text-area-error' : '', " ")
  }), showValidationError && (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message"
  }, "Please fill in the required field")))), showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    }
  }));
};

exports.KeywordBlockerPanelBody = KeywordBlockerPanelBody;

var KeywordBlockerPanelHeader = function KeywordBlockerPanelHeader(_ref2) {
  var statusText = _ref2.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "keywordBlocker",
    title: "Keyword blocker",
    statusText: statusText
  });
};

exports.KeywordBlockerPanelHeader = KeywordBlockerPanelHeader;

var LabelText = function LabelText() {
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-switch-label-text"
  }, "Enable keyword blocker"), (0, _preact.h)("div", null, "Topics and replies containing any of the following keywords or phrases will be sent to pending posts and require moderator approval before they'll be visible. This filter uses an exact match (e.g the 'duck' keyword will match 'duck' but not 'ducking', 'ducked', or 'duck123'; the phrase 'white duck' will match 'white duck' and 'white\xA0\xA0\xA0duck' but not 'white feathered duck' etc.). Please separate each keyword or phrase using a comma, e.g. duck, white duck."));
};

exports.LabelText = LabelText;